/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_Section_MineInputs */

const en_views_section_mine = /** @type {(inputs: Views_Section_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My views`)
};

const de_views_section_mine = /** @type {(inputs: Views_Section_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Ansichten`)
};

/**
* | output |
* | --- |
* | "My views" |
*
* @param {Views_Section_MineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_section_mine = /** @type {((inputs?: Views_Section_MineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Section_MineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_section_mine(inputs)
	return en_views_section_mine(inputs)
});